/**
 * @generated SignedSource<<5da67200e4ff7934ece54153a837650f>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPickerListItem_user",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserNameLabel_user"
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
};
node.hash = "4fcfde923631e3e9aa91e96f72611c00";
export default node;
